// context/NotificationContext.jsx
import React, { createContext, useState, useContext } from "react";

const NotificationContext = createContext();

export const useNotifications = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [failedSmsResults, setFailedSmsResults] = useState(null);

  const triggerRefresh = (results = null) => {
    setRefreshTrigger((prev) => prev + 1);
    if (results && results.failed > 0) {
      setFailedSmsResults(results);
      // Clear after 10 seconds
      setTimeout(() => {
        setFailedSmsResults(null);
      }, 10000);
    }
  };

  return (
    <NotificationContext.Provider
      value={{
        refreshTrigger,
        triggerRefresh,
        failedSmsResults,
        setFailedSmsResults,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};
